
import { useStore } from 'vuex'
import { ref, computed, onMounted } from 'vue'
import onTransitionendCallback from 'components/PageOverlay/methods/onTransitionendCallback'
import Editor from '@hugerte/hugerte-vue'
import { useHugeRTE, getEditorInit } from '../../foundation/js/loadHugeRTE'

export default {
    name: "ClosedGroupOverlay",
    components: {
        Editor
    },
    props: {
        groupId: {
            type: String,
            required: true
        }
    },
    setup(props) {
        const store = useStore()
        let close
        const groupId = computed(() => props.groupId ?? store.state.main.page_overlay_content_data.groupId)
        const isFrivilligContext = computed(() => store.state.main.page_overlay_content_data.isFrivilligContext ?? false)

        const applicationContent = ref('')
        const showInputErrors = ref(false)
        const { editorReady } = useHugeRTE()

        const isInputError = computed(() => !applicationContent.value?.length)
        const editorRef = ref(null)

        const getEditor = () => {
            if (typeof editorRef.value?.getEditor !== "function") {
                console.error('Unable to get editor in ClosedGroupOverlay')
                return null
            }
            return editorRef.value.getEditor()
        }

        const tabTrap = function (e) {
            if (e.shiftKey && e.target.dataset.order === 'last') {
                e.preventDefault()
                if (getEditor()) {
                    getEditor().focus()
                }
            }

            if (!e.shiftKey && e.target.dataset.order === 'last') {
                e.preventDefault()
                close.focus()
            }

            if (!e.shiftKey && !e.target.dataset.order) {
                e.preventDefault()
                close.focus()
            }
        }
        
        const getLabel = (labelKey) =>
            store.getters["labels/getLabel"]({
                labelCollection: "ClosedGroupOverlay",
                labelKey: labelKey,
            });

        const submitMemberApplication = async function () {
            showInputErrors.value = true

            if (isInputError.value) return

            const body = {
                content: applicationContent.value,
            }

            if (isFrivilligContext.value) {
                await store.dispatch('frivillige/joinGroup', {
                    reason: body.content,
                    gruppeKode: groupId.value,
                })
            }
            else if (applicationContent.value) {
                await store.dispatch('forum/submitMemberApplication', {
                    body: body,
                    id: groupId.value
                })
            }

            window.location.reload()
        }

        function editorInit() {
            return getEditorInit({
                plugins: 'emoticons autoresize lists autolink',
                toolbar: 'emoticons bold italic underline bullist numlist',
                toolbar_location: 'bottom',
                menubar: false,
                statusbar: false
            })
        }

        const decodeHtml = (htmlRaw) => {
            const txt = document.createElement('textarea')
            txt.innerHTML = htmlRaw
            return txt.value
        }

        const isDisabled = computed(() => decodeHtml(applicationContent.value.length) > 2000)

        onMounted(() => {
            close = document.querySelector('.kb-page-overlay__close')

            onTransitionendCallback({
                opening(){
                    close.focus()
                }
            }, { persistent: true })
        })

        return {
            tabTrap,
            editorRef,
            submitMemberApplication,
            applicationContent,
            isInputError,
            getEditor,
            showInputErrors,
            getLabel,
            editorInit,
            isDisabled,
            editorReady
        }
    }
}